import { css as _css } from "@emotion/core";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { MediaContext } from 'react-media-query-hoc';
import moment from 'moment-timezone';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import { Modal } from '@domain-group/fe-blueprint-ui/modal';
import { AddIcon, TickIcon } from '@domain-group/fe-co-icon';
import { SignInType } from '@domain-group/fe-allhomes-library';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import InspectionConfirm from './inspection-confirm';
import CalendarButton from './calendar-button';
import * as styles from './inspection.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DAY_FORMAT = 'dddd, D MMM';
var TIME_FORMAT = 'h:mma';
var buildSchema = _ref => {
  var startTime = _ref.startTime,
    endTime = _ref.endTime,
    address = _ref.address,
    listing = _ref.listing;
  return {
    '@context': 'http://schema.org',
    '@type': 'Event',
    name: 'Inspection',
    startDate: startTime,
    endDate: endTime,
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        name: address === null || address === void 0 ? void 0 : address.streetAddress,
        streetAddress: address === null || address === void 0 ? void 0 : address.streetAddress,
        addressLocality: address === null || address === void 0 ? void 0 : address.division,
        addressRegion: address === null || address === void 0 ? void 0 : address.state,
        postalCode: address === null || address === void 0 ? void 0 : address.postcode,
        url: listing === null || listing === void 0 ? void 0 : listing.url
      }
    }
  };
};
var Inspection = _ref2 => {
  var listing = _ref2.listing,
    startTime = _ref2.startTime,
    endTime = _ref2.endTime,
    address = _ref2.address,
    plannerPageUrl = _ref2.plannerPageUrl,
    isIdentityLoaded = _ref2.isIdentityLoaded,
    isSignedIn = _ref2.isSignedIn,
    isInInspectionPlan = _ref2.isInInspectionPlan,
    addInspectionToPlan = _ref2.addInspectionToPlan,
    removeInspectionFromPlan = _ref2.removeInspectionFromPlan,
    onRemoveFromPlanner = _ref2.onRemoveFromPlanner,
    onCalendarDownload = _ref2.onCalendarDownload,
    openSignIn = _ref2.openSignIn,
    openMaxAllowedPopup = _ref2.openMaxAllowedPopup,
    expanded = _ref2.expanded,
    position = _ref2.position;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    modal = _useState4[0],
    setModal = _useState4[1];
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  var buttonContainerRef = useRef();
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var closeModal = () => setModal(null);
  var addToPlan = () => {
    setPending(true);
    addInspectionToPlan(listing.id, startTime).then(result => {
      setPending(false);
      if (result) {
        setModal({
          success: true
        });
      }
    }).catch(error => {
      var _error$body;
      setPending(false);
      if (error !== null && error !== void 0 && (_error$body = error.body) !== null && _error$body !== void 0 && _error$body.maxAllowed) {
        openMaxAllowedPopup({
          maxAllowed: error.body.maxAllowed,
          buttonRef: buttonContainerRef.current
        });
      }
    });
  };
  var startDate = moment(startTime);
  var endDate = moment(endTime);
  var fullInspectionDateTime = "".concat(startDate.format(DAY_FORMAT), " ").concat(startDate.format(TIME_FORMAT), " - ").concat(endDate.format(TIME_FORMAT));
  var sendInspectionEvent = eventName => {
    sendEvent(eventName, {
      position,
      title: fullInspectionDateTime
    });
  };
  var handleAddToPlan = () => {
    sendInspectionEvent('add-inspection-click');
    if (mobile && !isSignedIn) {
      openSignIn(SignInType.TRIP_PLAN).then(success => {
        if (success) {
          addToPlan();
        }
      });
    } else {
      addToPlan();
    }
  };
  var handleRemoveFromPlan = () => {
    setPending(true);
    removeInspectionFromPlan(listing.id, startTime).then(() => setPending(false)).catch(() => setPending(false));
    onRemoveFromPlanner();
  };
  var isInPlanner = isInInspectionPlan({
    listingId: Number.parseInt(listing.id, 10),
    startTime
  });
  var location = "".concat(address.streetAddress, ", ").concat(address.division);
  var schema = buildSchema({
    startTime,
    endTime,
    listing,
    address
  });
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.inspection, expanded && styles.inspectionExpanded])
  }, ___EmotionJSX("div", {
    css: styles.date
  }, ___EmotionJSX("span", {
    css: styles.day
  }, startDate.format(DAY_FORMAT)), ___EmotionJSX("span", {
    css: styles.time
  }, startDate.format(TIME_FORMAT), " - ", endDate.format(TIME_FORMAT))), ___EmotionJSX("div", {
    "data-testid": "calendar-button"
  }, ___EmotionJSX(CalendarButton, {
    title: "Open Home",
    css: styles.calendarButton,
    startTime: startTime,
    endTime: endTime,
    listing: listing,
    location: location,
    onClick: () => sendInspectionEvent('calendar-click')
  })), isInPlanner ? ___EmotionJSX(Button, {
    disabled: pending,
    css: styles.plannerButton,
    appearance: "neutralFilled",
    size: "small",
    icon: pending ? ___EmotionJSX(Loader, {
      css: styles.spinner,
      size: "mini"
    }) : ___EmotionJSX(TickIcon, null),
    onClick: handleRemoveFromPlan
  }, "In my planner") : ___EmotionJSX("div", {
    css: styles.popupContainer,
    ref: buttonContainerRef
  }, ___EmotionJSX(Button, {
    disabled: pending || !isIdentityLoaded,
    css: styles.plannerButton,
    appearance: "secondaryNeutral",
    size: "small",
    icon: pending ? ___EmotionJSX(Loader, {
      css: styles.spinner,
      size: "mini"
    }) : ___EmotionJSX(AddIcon, null),
    onClick: handleAddToPlan
  }, "Add to planner")), schema && ___EmotionJSX("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(schema)
    } // eslint-disable-line react/no-danger
  }), modal && /*#__PURE__*/createPortal(___EmotionJSX(Modal, {
    closeCallback: closeModal,
    hasCloseAnimation: true,
    appearance: "standard",
    css: styles.modal
  }, ___EmotionJSX(InspectionConfirm, {
    plannerPageUrl: getAbsoluteUrl(plannerPageUrl),
    listing: listing,
    location: location,
    startTime: startTime,
    endTime: endTime,
    onCalendarClick: onCalendarDownload,
    onCloseClick: closeModal
  })), document.body));
};
Inspection.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    imageUrl: PropTypes.string,
    beds: PropTypes.number,
    baths: PropTypes.number,
    parking: PropTypes.number
  }).isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  address: PropTypes.shape({
    streetAddress: PropTypes.string,
    division: PropTypes.string,
    postcode: PropTypes.string,
    state: PropTypes.string
  }).isRequired,
  plannerPageUrl: PropTypes.string,
  onRemoveFromPlanner: PropTypes.func,
  onCalendarDownload: PropTypes.func,
  isInInspectionPlan: PropTypes.func,
  isSignedIn: PropTypes.bool,
  isIdentityLoaded: PropTypes.bool,
  addInspectionToPlan: PropTypes.func,
  removeInspectionFromPlan: PropTypes.func,
  openSignIn: PropTypes.func,
  openMaxAllowedPopup: PropTypes.func,
  expanded: PropTypes.bool,
  position: PropTypes.number
};
Inspection.defaultProps = {
  plannerPageUrl: '/inspection-planner',
  onRemoveFromPlanner: () => {},
  onCalendarDownload: () => {},
  isInInspectionPlan: () => false,
  isSignedIn: false,
  isIdentityLoaded: false,
  addInspectionToPlan: () => {},
  removeInspectionFromPlan: () => {},
  openSignIn: () => {},
  openMaxAllowedPopup: () => {},
  expanded: false,
  position: 0
};
export default withAllhomesContext('isIdentityLoaded', 'isSignedIn', 'isInInspectionPlan', 'addInspectionToPlan', 'removeInspectionFromPlan', 'openSignIn')(Inspection);